import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const updateSurfaceNodePositionMutation = gql`
  mutation updateSurfaceNodePosition($input: UpdateSurfaceNodePositionInput!) {
    updateSurfaceNodePosition(input: $input) {
      success
      error
    }
  }
`;

export default mutation(updateSurfaceNodePositionMutation);
